import { Fragment } from 'react';

import { Button } from '@nesso/ui/primitives/button';

import type { ContactClientLink } from '../model/client.types';
import { openClientChartInPlace } from '../model/open-client-chart-in-place';

type Props = {
    links: ContactClientLink[];
};

export function ContactForLinks({ links }: Props) {
    if (links.length === 0) return null;

    return (
        <p className="text-base text-muted-foreground">
            Contact for{' '}
            {links.map((link, index) => (
                <Fragment key={link.clientId}>
                    {index > 0 && ', '}
                    <Button
                        type="button"
                        variant="inline-link"
                        onClick={() =>
                            openClientChartInPlace({ id: link.clientId, name: link.clientName })
                        }
                    >
                        {link.clientName}
                    </Button>
                </Fragment>
            ))}
        </p>
    );
}
